"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _Text = _interopRequireDefault(require("../../../components/Text"));
var _BubbleSelectBlock = _interopRequireDefault(require("../../../components/BubbleSelectBlock"));
var _Slider = _interopRequireDefault(require("../../../components/Slider"));
var _NumberInput = _interopRequireDefault(require("../../../components/TextFields/NumberInput"));
var _sbUtils = require("@simplybenefits/sb-utils");
var _i18n = _interopRequireDefault(require("../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CoverageSelection = /*#__PURE__*/function (_PureComponent) {
  function CoverageSelection() {
    var _this;
    (0, _classCallCheck2["default"])(this, CoverageSelection);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, CoverageSelection, [].concat(args)), _this._getPremiumAndRate = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(volume, entityType) {
        var grossRate, premium;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.props.getRate(_this.props.product, volume, _this.props.member, entityType);
            case 2:
              grossRate = _context.sent;
              // eslint-disable-next-line no-eval
              premium = eval(_this.props.product.calculations.premium);
              return _context.abrupt("return", [grossRate, premium]);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(), _this._handleCoverageChange = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(volume) {
        var entityType,
          _yield$_this$_getPrem,
          _yield$_this$_getPrem2,
          grossRate,
          premium,
          data,
          _yield$_this$_getPrem3,
          dependentGrossRate,
          dependentPremium,
          _yield$_this$_getPrem4,
          _yield$_this$_getPrem5,
          spouseGrossRate,
          spousePremium,
          _yield$_this$_getPrem6,
          _yield$_this$_getPrem7,
          childGrossRate,
          childPremium,
          _args2 = arguments;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              entityType = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 'primary';
              _context2.next = 3;
              return _this._getPremiumAndRate(volume, entityType);
            case 3:
              _yield$_this$_getPrem = _context2.sent;
              _yield$_this$_getPrem2 = (0, _slicedToArray2["default"])(_yield$_this$_getPrem, 2);
              grossRate = _yield$_this$_getPrem2[0];
              premium = _yield$_this$_getPrem2[1];
              data = _objectSpread(_objectSpread({}, _this.props.purchaseData), {}, (0, _defineProperty2["default"])({}, entityType, _objectSpread(_objectSpread({}, _this.props.purchaseData[entityType]), {}, {
                grossRate: grossRate,
                volume: volume,
                premium: premium
              }))); // if the product has auto volume setting for dependents (like CI for allstate, spouse gets 50% of primary volume) then set their volume and premiums based on the selected member volume and the volume multiplier
              if (!(_this.props.product.dependentCoverageSetting.primaryVolumeMultiplier && entityType === 'primary')) {
                _context2.next = 41;
                break;
              }
              if (!_this.props.purchaseData.dependent) {
                _context2.next = 19;
                break;
              }
              data.dependent.volume = volume * _this.props.product.dependentCoverageSetting.primaryVolumeMultiplier;
              if (!_this.props.purchaseData.dependent.included) {
                _context2.next = 19;
                break;
              }
              _context2.next = 14;
              return _this._getPremiumAndRate(data.primary.volume, 'dependent');
            case 14:
              _yield$_this$_getPrem3 = _context2.sent;
              dependentGrossRate = _yield$_this$_getPrem3.dependentGrossRate;
              dependentPremium = _yield$_this$_getPrem3.dependentPremium;
              data.dependent.grossRate = dependentGrossRate;
              data.dependent.premium = dependentPremium;
            case 19:
              if (!_this.props.purchaseData.spouse) {
                _context2.next = 30;
                break;
              }
              data.spouse.volume = volume * _this.props.product.dependentCoverageSetting.primaryVolumeMultiplier;
              if (!_this.props.purchaseData.spouse.included) {
                _context2.next = 30;
                break;
              }
              _context2.next = 24;
              return _this._getPremiumAndRate(data.primary.volume, 'spouse');
            case 24:
              _yield$_this$_getPrem4 = _context2.sent;
              _yield$_this$_getPrem5 = (0, _slicedToArray2["default"])(_yield$_this$_getPrem4, 2);
              spouseGrossRate = _yield$_this$_getPrem5[0];
              spousePremium = _yield$_this$_getPrem5[1];
              data.spouse.grossRate = spouseGrossRate;
              data.spouse.premium = spousePremium;
            case 30:
              if (!_this.props.purchaseData.child) {
                _context2.next = 41;
                break;
              }
              data.child.volume = volume * _this.props.product.dependentCoverageSetting.primaryVolumeMultiplier;
              if (!_this.props.purchaseData.child) {
                _context2.next = 41;
                break;
              }
              _context2.next = 35;
              return _this._getPremiumAndRate(data.primary.volume, 'child');
            case 35:
              _yield$_this$_getPrem6 = _context2.sent;
              _yield$_this$_getPrem7 = (0, _slicedToArray2["default"])(_yield$_this$_getPrem6, 2);
              childGrossRate = _yield$_this$_getPrem7[0];
              childPremium = _yield$_this$_getPrem7[1];
              data.child.grossRate = childGrossRate;
              data.child.premium = childPremium;
            case 41:
              _context2.next = 43;
              return _this.props.savePurchaseData(data);
            case 43:
              return _context2.abrupt("return", null);
            case 44:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }(), _this._handleDependentMetaChange = /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(entityType, field, value) {
        var volume, grossRate, premium, data;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(_this.props.purchaseData.spouse.included && value)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return", null);
            case 2:
              if (!(!_this.props.purchaseData.spouse.included && !value)) {
                _context3.next = 4;
                break;
              }
              return _context3.abrupt("return", null);
            case 4:
              // if we reduced the dependent volume amount based on the primaries coverage amount (opt CI) ensure we use the primary volume amount to calculate the dependents gross rate
              volume = _this.props.product.dependentCoverageSetting.primaryVolumeMultiplier ? _this.props.purchaseData.primary.volume : _this.props.purchaseData[entityType].volume;
              if (!value) {
                _context3.next = 11;
                break;
              }
              _context3.next = 8;
              return _this.props.getRate(_this.props.product, volume, _this.props.member, entityType);
            case 8:
              _context3.t0 = _context3.sent;
              _context3.next = 12;
              break;
            case 11:
              _context3.t0 = 0;
            case 12:
              grossRate = _context3.t0;
              // eslint-disable-next-line no-eval
              premium = value ? eval(_this.props.product.calculations.premium) : 0;
              data = _objectSpread(_objectSpread({}, _this.props.purchaseData), {}, (0, _defineProperty2["default"])({}, entityType, _objectSpread(_objectSpread({}, _this.props.purchaseData[entityType]), {}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, field, value), "grossRate", grossRate), "premium", premium))));
              _context3.next = 17;
              return _this.props.savePurchaseData(data);
            case 17:
              return _context3.abrupt("return", null);
            case 18:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x4, _x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }(), (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _inherits2["default"])(CoverageSelection, _PureComponent);
  return (0, _createClass2["default"])(CoverageSelection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._handleCoverageChange(this.props.purchaseData.primary.volume);
    }

    /**
     * Retrieves the gross rate and premium based on the specified volume and entity type.
     *
     * @async
     * @function
     * @param {number} volume - The volume for rate calculation.
     * @param {string} entityType - The type of the entity for rate calculation.
     * @returns {Promise<Array<number>>} - Resolves with an array containing the gross rate and premium.
     * @private
     */

    /**
     * Handles the change in coverage by updating the volume, gross rate, and premium for the specified entity type.
     *
     * @async
     * @function
     * @param {number} volume - The new volume for coverage.
     * @param {string} [entityType='primary'] - The type of the entity for which coverage is being changed.
     * @returns {Promise<void>} - Resolves once the purchase data is successfully updated.
     */

    /**
     * Handles changes in meta data for dependent entities, recalculating and updating relevant purchase data.
     *
     * @async
     * @function
     * @param {string} entityType - The type of the dependent entity.
     * @param {string} field - The field being updated in the dependent meta data.
     * @param {string|number|boolean} value - The new value for the specified field.
     * @returns {Promise<null>} - Resolves when the purchase data is updated.
     */
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var product = this.props.product;
      var name = "".concat(product.type.toUpperCase() === 'VOLUNTARY' ? _i18n["default"].t(_tokens["default"].labels.marketplace.voluntary) : _i18n["default"].t(_tokens["default"].labels.marketplace.optional), " ").concat(product.name.primary[this.props.member.language]);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        margin: "0 0 10px 0"
      }, product.type.toUpperCase() === 'VOLUNTARY' ? _i18n["default"].t(_tokens["default"].labels.marketplace.selectCoverageAmountVoluntary) : _i18n["default"].t(_tokens["default"].labels.marketplace.selectCoverageAmountOptional)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        color: "#000",
        small: true,
        bold: true,
        flex: 1,
        margin: "20px 0 10px 0"
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.selectCoverageAmountInfo)), /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
        value: this.props.purchaseData.primary.volume,
        min: product.coverageRange.min,
        max: product.coverageRange.max,
        step: product.coverageRange.step,
        onBlur: function onBlur(value) {
          return _this2._handleCoverageChange(value);
        }
      }), /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.marketplace.yourCoverageAmount),
        prefix: "$ ",
        value: this.props.purchaseData.primary.volume,
        disabled: true,
        required: true,
        variant: "outlined",
        customStyle: {
          marginRight: 1,
          width: 250
        }
      }), /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.marketplace.monthlyCost),
        prefix: "$ ",
        value: this.props.purchaseData.primary.premium,
        required: true,
        variant: "outlined",
        disabled: true,
        customStyle: {
          width: 250
        }
      }), product.verbiages.setCoverage.dependentCoverageNote1 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        color: "#000",
        small: true,
        light: true,
        margin: "10px 0 0 0"
      }, product.verbiages.setCoverage.dependentCoverageNote1[this.props.member.language]), this.props.purchaseData.allowedDependentCoverage && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.props.purchaseData.dependent && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        color: "#000",
        small: true,
        light: true,
        margin: "10px 0 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.purchaseDependentCoverage)), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].buttons.yes),
          selected: this.props.purchaseData.dependent.included === true,
          field: 'yes'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].buttons.no),
          selected: this.props.purchaseData.dependent.included === false,
          field: 'no'
        },
        handleChange: function handleChange(field) {
          return _this2._handleDependentMetaChange('dependent', 'included', field === 'yes');
        },
        whitelabel: this.props.whitelabel
      }), this.props.purchaseData.dependent.included && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        color: "#000",
        medium: true,
        bold: true,
        margin: "10px 0 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.dependentCoverage)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        color: "#000",
        small: true,
        light: true,
        margin: "10px 0 15px 0"
      }, product.verbiages.setCoverage.dependentCoverageNote2[this.props.member.language]), this.props.product.dependentCoverageSetting.allowed && /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
        value: this.props.purchaseData.dependent.volume,
        min: product.coverageRange.min,
        max: product.coverageRange.max,
        step: product.coverageRange.step,
        onChange: function onChange(value) {
          return _this2._handleCoverageChange(value, 'dependent');
        }
      }), /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.marketplace.dependentCoverageAmount),
        prefix: "$ ",
        value: this.props.purchaseData.dependent.volume,
        variant: "outlined",
        customStyle: {
          marginRight: 10,
          width: 250
        },
        disabled: true,
        required: true
      }))), this.props.purchaseData.spouse && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        color: "#000",
        small: true,
        light: true,
        margin: "10px 0 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.purchaseSpouseCoverage)), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].buttons.yes),
          selected: this.props.purchaseData.spouse.included === true,
          field: 'yes'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].buttons.no),
          selected: this.props.purchaseData.spouse.included === false,
          field: 'no'
        },
        handleChange: function handleChange(field) {
          return _this2._handleDependentMetaChange('spouse', 'included', field === 'yes');
        },
        whitelabel: this.props.whitelabel
      }), Boolean(this.props.purchaseData.spouse.included) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        color: "#000",
        medium: true,
        bold: true,
        margin: "10px 0 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.spouseCoverage)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        color: "#000",
        small: true,
        light: true,
        margin: "10px 0 15px 0"
      }, product.verbiages.setCoverage.dependentCoverageNote2[this.props.member.language]), this.props.product.dependentCoverageSetting.allowed && /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
        value: this.props.purchaseData.spouse.volume,
        min: product.coverageRange.min,
        max: product.coverageRange.max,
        step: product.coverageRange.step,
        onChange: function onChange(value) {
          return _this2._handleCoverageChange(value, 'spouse');
        }
      }), /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.marketplace.spouseCoverageAmount),
        prefix: "$ ",
        value: this.props.purchaseData.spouse.volume,
        variant: "outlined",
        customStyle: {
          marginRight: 10,
          width: 250
        },
        disabled: true,
        required: true
      }))), this.props.purchaseData.child && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        color: "#000",
        small: true,
        light: true,
        margin: "10px 0 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.purchaseChildCoverage)), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].buttons.yes),
          selected: this.props.purchaseData.child.included === true,
          field: 'yes'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].buttons.no),
          selected: this.props.purchaseData.child.included === false,
          field: 'no'
        },
        handleChange: function handleChange(field) {
          return _this2._handleDependentMetaChange('child', 'included', field === 'yes');
        },
        whitelabel: this.props.whitelabel
      }), this.props.purchaseData.child.included && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        color: "#000",
        medium: true,
        bold: true,
        margin: "10px 0 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.childCoverage)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        color: "#000",
        small: true,
        light: true,
        margin: "10px 0 15px 0"
      }, product.verbiages.setCoverage.dependentCoverageNote2[this.props.member.language]), this.props.product.dependentCoverageSetting.allowed && /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
        value: this.props.purchaseData.dependent.volume,
        min: product.coverageRange.min,
        max: product.coverageRange.max,
        step: product.coverageRange.step,
        onChange: function onChange(value) {
          return _this2._handleCoverageChange(value, 'dependent');
        }
      }), /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.marketplace.childCoverageAmount),
        prefix: "$ ",
        value: this.props.purchaseData.child.volume,
        variant: "outlined",
        customStyle: {
          marginRight: 10,
          width: 250
        },
        disabled: true,
        required: true
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          flex: 1,
          flexDirection: 'row'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        color: "#000",
        mediumLarge: true,
        bold: true,
        margin: "20px 0 10px 0",
        customStyle: {
          flex: 1
        }
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.productTotal, {
        product: name
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-end'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        color: "#000",
        mediumLarge: true,
        bold: true,
        margin: "20px 0 10px 0"
      }, _sbUtils.helpers.formatNumber(this.props.purchaseData.primary.premium + (this.props.purchaseData.child ? this.props.purchaseData.child.premium : 0) + (this.props.purchaseData.spouse ? this.props.purchaseData.spouse.premium : 0) + (this.props.purchaseData.dependent ? this.props.purchaseData.dependent.premium : 0), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        color: "#000",
        mediumLarge: true,
        light: true,
        margin: "20px 0 10px 0"
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.perMonth)))));
    }
  }]);
}(_react.PureComponent);
var _default = exports["default"] = CoverageSelection;